import {API, axios, SendRequest} from '@/imports-files/pages/admins/otp';


export class Otp extends SendRequest {
  async verifyOtp(params) {
    try{
      const result = await axios.post( API.admins.OTP_VERIFY_URL,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch(error){
      console.log("bad Response")
      console.log(error)
    }
  }

  async resendOtp(params) {
    const result = await axios.post( API.admins.RESEND_OTP_URL,
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());

    return result;
  }

  async set_jwttoken_on_client_side_cookie(params) {
    const result = await axios.post( API.API_SET_AUTH_TOKEN,
        JSON.stringify({'data': params.headers.authorization}),
        this.setHeaderJSON());

    return result.data;
  }
}
